import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {Dropdown, DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {
  DropdownHeader,
  DropdownHeaderProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownHeader';
import {DropdownList} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import noAnswers from '../../../../assets/images/noAnswers.svg';
import {DropdownCategory} from '../../../common/dropdowns/dropdownCategory';
import {DropdownEmpty} from '../../../common/dropdowns/dropdownEmpty';
import {DropdownItemSeparator} from '../../../common/dropdowns/dropdownItemSeparator';
import {AnswersDropdownCreateRow} from './answersDropdownCreateRow';

/*
 * Props.
 */

interface AnswersDropdownEmptyProps extends DropdownProps, DropdownHeaderProps {
  isQuickInsert: boolean;
  editorText: string;
  backButtonLabel: ReactNode;
  onBackButtonClick: Handler;
  onCreateClick: Handler;
}

/*
 * Style.
 */

const StyledEmptyAnswersWrapperDiv = styled.div`
  text-align: center;
  padding: 0px 20px;
  line-height: 20px;
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

export const AnswersDropdownEmpty: FC<AnswersDropdownEmptyProps> = (props) => {
  const {title, ...dropdownProps} = props;
  return (
    <Dropdown {...dropdownProps}>
      <DropdownHeader title={title} leftIcon={renderBackButton(props)} />
      <DropdownList {...dropdownProps} defaultHighlightedIndex={1}>
        <DropdownCategory>
          <Trans id="answers-dropdown-empty-create-title">Create</Trans>
        </DropdownCategory>
        <AnswersDropdownCreateRow
          editorText={props.editorText}
          isFromDraft={!props.isQuickInsert}
          onSelect={props.onCreateClick}
          index={1} // <DropdownCategory /> above is 0
        />
        <DropdownItemSeparator />
        <DropdownEmpty imageSource={noAnswers}>
          <StyledEmptyAnswersWrapperDiv>
            <Trans id="answers-dropdown-empty-create-description">
              Reply faster by creating a message template.
            </Trans>
          </StyledEmptyAnswersWrapperDiv>
        </DropdownEmpty>
      </DropdownList>
    </Dropdown>
  );
};

function renderBackButton(props: AnswersDropdownEmptyProps) {
  if (!props.backButtonLabel) {
    return null;
  }

  return (
    <IconButton iconName="chevronLeftSmall" label={props.backButtonLabel} onClick={props.onBackButtonClick} />
  );
}
